import React, { useContext, useRef, useState, useEffect } from 'react';
import { GameDataContext } from '../providers/GameDataProvider';
import { formatWinrate, getWinrateColor } from '../utils/utils';
import TimelineControlBarBackground from '../icons/timeline_controlbar.png';
import TimelineControlBarIndexer from '../icons/timeline_controlbar_indexer.png';
import TimelineControlBarPlay from '../icons/timeline_controlbar_play.png';
import TimelineControlBarPause from '../icons/timeline_controlbar_pause.png';
import TimelineControlBarPlus from '../icons/timeline_controlbar_plus.png';
import TimelineControlBarMinus from '../icons/timeline_controlbar_minus.png';
import WinrateLineChartMini from './WinrateLineChartMini';
var TimelineControlBar = function (_a) {
    var i = _a.i, setIndex = _a.setIndex;
    var gameData = useContext(GameDataContext);
    var barRef = useRef(null);
    var _b = useState(false), isDragging = _b[0], setIsDragging = _b[1];
    var _c = useState(null), startX = _c[0], setStartX = _c[1];
    var _d = useState(1), multiplier = _d[0], setMultiplier = _d[1];
    var _e = useState(false), isPlaying = _e[0], setIsPlaying = _e[1];
    var pause = useRef(null);
    var handleMouseMove = function (event) {
        if (!isDragging)
            return;
        var rect = barRef.current.getBoundingClientRect();
        var x = event.clientX - rect.left;
        var scaledX = x / rect.width;
        var adjustedX = Math.max(0, Math.min(scaledX, 1));
        var index = Math.round(adjustedX * (gameData.snapshots.length - 1));
        setIndex(index);
    };
    var handleMouseDown = function (event) {
        setIsDragging(true);
        setStartX(event.clientX);
    };
    var handleMouseUp = function (event) {
        if (isDragging) {
            setIsDragging(false);
            if (Math.abs(event.clientX - startX) < 5) {
                var rect = barRef.current.getBoundingClientRect();
                var x = event.clientX - rect.left;
                var scaledX = x / rect.width;
                var adjustedX = Math.max(0, Math.min(scaledX, 1));
                var index = Math.round(adjustedX * (gameData.snapshots.length - 1));
                setIndex(index);
            }
        }
    };
    var play = function (multiplier) {
        var interval = setInterval(function () {
            setIndex(function (index) { return Math.min(gameData.snapshots.length - 1, Math.max(0, index + 1)); });
        }, 3000 / multiplier);
        return function () {
            clearInterval(interval);
        };
    };
    var handlePlayPauseClick = function () {
        if (isPlaying) {
            setIsPlaying(false);
            pause.current();
        }
        else {
            setIsPlaying(true);
            pause.current = play(multiplier);
        }
    };
    var handleSpeedChange = function (direction) {
        var newMultiplier = Math.max(1, Math.min(64, multiplier * direction));
        setMultiplier(newMultiplier);
        if (isPlaying) {
            pause.current();
            pause.current = play(newMultiplier);
        }
        else {
            pause.current = play(newMultiplier);
            setIsPlaying(true);
        }
    };
    useEffect(function () {
        if (isDragging) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        }
        else {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        }
        return function () {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging]);
    useEffect(function () {
        var handleKeyPress = function (event) {
            switch (event.key) {
                case 'p':
                case 'P':
                    handlePlayPauseClick();
                    break;
                case '+':
                case '=':
                    handleSpeedChange(2);
                    break;
                case '-':
                case '_':
                    handleSpeedChange(0.5);
                    break;
                default:
                    break;
            }
        };
        window.addEventListener('keydown', handleKeyPress);
        return function () {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [multiplier, isPlaying]);
    var minutes = Math.floor(gameData.snapshots[i].time / 60);
    var seconds = Math.floor(gameData.snapshots[i].time % 60);
    return (React.createElement("div", { style: { position: 'relative', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 10 } },
        React.createElement("div", { style: { position: 'absolute', left: 0, height: '100%', width: 75, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 22, fontWeight: 600, color: getWinrateColor(gameData.snapshots[i].winrate) } },
            formatWinrate(gameData.snapshots[i].winrate),
            "%"),
        React.createElement("div", { style: { height: '100%', width: 75, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 20, fontWeight: 600, color: 'white' } }, "".concat(minutes, ":").concat(seconds < 10 ? '0' : '').concat(seconds)),
        React.createElement("div", { style: { position: 'relative', height: '100%', width: '65%' } },
            React.createElement("img", { src: TimelineControlBarBackground, style: { position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }, draggable: false }),
            React.createElement("div", { style: { position: 'absolute', left: '3%', top: '50%', width: 50, height: '90%', transform: 'translate(0%, -50%)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' } },
                React.createElement("div", { style: { width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                    isPlaying ?
                        React.createElement("img", { src: TimelineControlBarPause, style: { width: 20, height: 20, cursor: 'pointer' }, draggable: false, onClick: handlePlayPauseClick })
                        :
                            React.createElement("img", { src: TimelineControlBarPlay, style: { width: 20, height: 20, cursor: 'pointer' }, draggable: false, onClick: handlePlayPauseClick }),
                    React.createElement("div", { style: { width: 20, height: 20, marginLeft: 5, fontSize: 13, display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                        multiplier,
                        "x")),
                React.createElement("div", { style: { width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 5 } },
                    React.createElement("img", { src: TimelineControlBarMinus, style: { width: 20, height: 20, cursor: 'pointer' }, draggable: false, onClick: function () { return handleSpeedChange(0.5); } }),
                    React.createElement("img", { src: TimelineControlBarPlus, style: { width: 20, height: 20, cursor: 'pointer', marginLeft: 5 }, draggable: false, onClick: function () { return handleSpeedChange(2); } }))),
            React.createElement("div", { ref: barRef, style: { position: 'absolute', left: '12%', top: 0, width: '86%', height: '100%' }, onMouseDown: handleMouseDown },
                React.createElement("div", { style: { position: 'relative', width: '100%', height: '100%' } },
                    React.createElement("div", { style: { position: 'absolute', left: '-1.8%', top: 0, width: '102%', height: '100%' } },
                        React.createElement(WinrateLineChartMini, { allyTeam: gameData.playerTeam, snapshots: gameData.snapshots, winrates: gameData.snapshots.map(function (s) { return s.winrate; }), maxTime: gameData.snapshots[gameData.snapshots.length - 1].time })),
                    React.createElement("img", { src: TimelineControlBarIndexer, style: { position: 'absolute', left: "".concat(i / (gameData.snapshots.length - 1) * 100, "%"), top: 0, width: 'auto', height: '100%', transform: 'translate(-50%, 0)' }, draggable: false }))))));
};
export default TimelineControlBar;
